module.exports = [
  // DE
  { type: "home_page", path: "/", lang: "de-de" },
  { type: "page", path: "/:uid", lang: "de-de" },
  {
    type: "treatment_category",
    path: "/leistungen/:uid",
    lang: "de-de",
  },
  {
    type: "treatment",
    resolvers: {
      category: "treatment_category",
    },
    path: "/leistungen/:category/:uid",
    lang: "de-de",
  },
  { type: "journal_article", path: "/journal/:uid", lang: "de-de" },
  { type: "team_member", path: "/team/:uid", lang: "de-de" },

  // EN
  { type: "home_page", path: "/en/", lang: "en" },
  { type: "page", path: "/en/:uid", lang: "en" },
  {
    type: "treatment_category",
    path: "/en/treatments/:uid",
    lang: "en",
  },
  {
    type: "treatment",
    resolvers: {
      category: "treatment_category",
    },
    path: "/en/treatments/:category/:uid",
    lang: "en",
  },
  { type: "journal_article", path: "/en/journal-en/:uid", lang: "en" },
  { type: "team_member", path: "/en/team-en/:uid", lang: "en" },
];
